import { render, staticRenderFns } from "./display.vue?vue&type=template&id=1303fd10&scoped=true"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"
import style0 from "./display.vue?vue&type=style&index=0&id=1303fd10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1303fd10",
  null
  
)

export default component.exports